export default __webpack_public_path__ + "static/media/bu-nurul.5d3adcb7.png";